import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
//MUI
import { Box, Divider, FormControl, Stack, Grid } from "@mui/material";

import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UDataGrid from "../../components/mui/UDataGrid";
import { API, PAGE } from "../../config";
import { fni18n } from "../../services/commonService";
import { getAPI } from "../../services/commonService";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { theme } from "../../assets/themes";
import UButton from "../../components/mui/UButton";
import UDatePickers from "../../components/mui/UDatePickers";
import UAlertDialog from "../../components/mui/UAlertDialog";
import UTable from "../../components/mui/UTable";
import { makeStyles } from "@material-ui/core/styles";
import UTableTotal from "../../components/mui/UTableTotal";
import UTextField from "../../components/mui/UTextField";
import { useTranslation } from "react-i18next";

const columns = [
  {
    field: "id",
    headerName: "No",
    width: 50,
    hide: true,
  },
  {
    field: "userId",
    //headerName: 'User Id',
    headerName: "사원번호",
    width: 110,
    hide: true,
  },
  {
    field: "userName",
    //headerName: 'User Name',
    headerName: "사원명",
    width: 150,
    headerAlign: "center",
    align: "center",
    hide: true,
  },
  {
    field: "transactionDate",
    headerName: "거래일자",
    width: 170,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "cdNm",
    headerName: "거래유형",
    width: 120,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "machId",
    headerName: "기기번호",
    width: 125,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "deposit",
    headerName: "입금",
    width: "25%",
    headerAlign: "center",
    align: "center",
    id: 20,
    colSpan: [
      {
        parentField: "deposit",
        field: "billDepAmt",
        //headerName: 'inTotalAmt',
        headerName: "지폐",
        width: 80,
        headerAlign: "center",
        align: "center",
        valueFormatter: (params) => {
          if (params.value.startsWith('-$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                  color: "red",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else if (params.value.startsWith('$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                -
              </div>
            );
          }
        },
      },
      {
        parentField: "deposit",
        field: "coinDepAmt",
        //headerName: 'inTotalAmt',
        headerName: "동전",
        width: 80,
        headerAlign: "center",
        align: "center",
        valueFormatter: (params) => {
          if (params.value.startsWith('-$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                  color: "red",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else if (params.value.startsWith('$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                -
              </div>
            );
          }
        },
      },
      {
        parentField: "deposit",
        field: "checkDepAmt",
        //headerName: 'inTotalAmt',
        headerName: "수표",
        width: 80,
        headerAlign: "center",
        align: "center",
        valueFormatter: (params) => {
          if (params.value.startsWith('-$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                  color: "red",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else if (params.value.startsWith('$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                -
              </div>
            );
          }
        },
      },
      {
        parentField: "deposit",
        field: "inTotalAmt",
        //headerName: 'inTotalAmt',
        headerName: "소계",
        width: 130,
        headerAlign: "center",
        align: "center",
        valueFormatter: (params) => {
          if (params.value.startsWith('-$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                  color: "red",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else if (params.value.startsWith('$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                -
              </div>
            );
          }
        },
      },
    ],
  },
  {
    field: "dispense",
    headerName: "출금",
    width: "25%",
    headerAlign: "center",
    align: "center",
    id: 20,
    colSpan: [
      {
        parentField: "dispense",
        field: "billDisAmt",
        //headerName: 'inTotalAmt',
        headerName: "지폐",
        width: 80,
        headerAlign: "center",
        align: "center",
        valueFormatter: (params) => {
          if (params.value.startsWith('-$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                  color: "red",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else if (params.value.startsWith('$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                -
              </div>
            );
          }
        },
      },
      {
        parentField: "dispense",
        field: "coinDisAmt",
        //headerName: 'coinDisAmt',
        headerName: "동전",
        width: 80,
        headerAlign: "center",
        align: "center",
        valueFormatter: (params) => {
          if (params.value.startsWith('-$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                  color: "red",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else if (params.value.startsWith('$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                -
              </div>
            );
          }
        },
      },
      {
        parentField: "dispense",
        field: "outTotalAmt",
        //headerName: 'outTotalAmt',
        headerName: "소계",
        width: 130,
        headerAlign: "center",
        align: "center",
        valueFormatter: (params) => {
          if (params.value.startsWith('-$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                  color: "red",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else if (params.value.startsWith('$')) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                }}
              >
                {params.value}
                &nbsp;&nbsp;
              </div>
            );
          } else {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                -
              </div>
            );
          }
        },
      },
    ],
  },
  {
    field: "net",
    //headerName: 'outTotalAmt',
    headerName: "누계",
    width: 150,
    headerAlign: "center",
    align: "center",
    valueFormatter: (params) => {
      if (params.value.startsWith('-$')) {
        return (
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "right",
              color: "red",
            }}
          >
            {params.value}
            &nbsp;&nbsp;
          </div>
        );
      } else if (params.value.startsWith('$')) {
        return (
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "right",
            }}
          >
            {params.value}
            &nbsp;&nbsp;
          </div>
        );
      } else {
        return (
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            -
          </div>
        );
      }
    },
  },
];

export default function CloseUserPopUpPage(props) {
  const { t } = useTranslation();
  const storeCd = props.data.storeCd;
  const userId = props.data.userId;
  const date = props.data.date;
  const [search, setSearch] = useState({
    storeCd: storeCd,
    startDate: date,
    endDate: date,
    userId: userId,
  });

  const [errorPopupOpen, setErrorPopupOpen] = useState(false); // error dialog
  const [errorMsg, setErrorMsg] = useState(""); // api error message

  const [list, setList] = useState([]);
  const [total, setTotal] = useState([]);
  //화면 로드 시
  useEffect(() => {
    const getLoadData = async () => {
      try {
        await onButtonClick("조회");
      } catch (e) {}
    };
    getLoadData();
  }, []);

  const handleErrorOpen = () => {
    setErrorPopupOpen(true);
  };
  const handleErrorClose = () => {
    setErrorPopupOpen(false);
  };
  //DataGrid에서 row 선택 시
  function onSelectedRow(row) {
    //alert("selection:"+row.lastName);
  }
  const onSelectedRows = (e, row) => {};
  const onSearchChange = (e) => {
    const { name, value } = e.target;
    setSearch({
      ...search,
      [name]: value,
    });
  };

  async function onButtonClick(dvsn) {
    if (dvsn === "조회") {
      await getAPI(API.CASH.CLOSE_USER_DETAIL + userId, search).then((res) => {
        if (res.data.code === 200) {
          const _inputData = res.data.result.map((rowData) => ({
            id: rowData.no,
            userId: rowData.userId,
            userName: rowData.userName,
            transactionDate: rowData.trnsctDt,
            cdNm: rowData.cdNm,
            machId: rowData.machId,
            billDepAmt: isNaN(rowData.billDepAmt)?"-":rowData.billDepAmt>=0?"$ "+Number(rowData.billDepAmt).toLocaleString("en-US"):"-$ "+Number(rowData.billDepAmt*-1).toLocaleString("en-US"),
            coinDepAmt: isNaN(rowData.coinDepAmt)?"-":rowData.coinDepAmt>=0?"$ "+Number(rowData.coinDepAmt).toLocaleString("en-US"):"-$ "+Number(rowData.coinDepAmt*-1).toLocaleString("en-US"),
            checkDepAmt: isNaN(rowData.checkDepAmt)?"-":rowData.checkDepAmt>=0?"$ "+Number(rowData.checkDepAmt).toLocaleString("en-US"):"-$ "+Number(rowData.checkDepAmt*-1).toLocaleString("en-US"),
            inTotalAmt: isNaN(rowData.inTotAmt)?"-":rowData.inTotAmt>=0?"$ "+Number(rowData.inTotAmt).toLocaleString("en-US"):"-$ "+Number(rowData.inTotAmt*-1).toLocaleString("en-US"),
            billDisAmt: isNaN(rowData.billDisAmt)?"-":rowData.billDisAmt>=0?"$ "+Number(rowData.billDisAmt).toLocaleString("en-US"):"-$ "+Number(rowData.billDisAmt*-1).toLocaleString("en-US"),
            coinDisAmt: isNaN(rowData.coinDisAmt)?"-":rowData.coinDisAmt>=0?"$ "+Number(rowData.coinDisAmt).toLocaleString("en-US"):"-$ "+Number(rowData.coinDisAmt*-1).toLocaleString("en-US"),
            outTotalAmt: isNaN(rowData.outTotAmt)?"-":rowData.outTotAmt>=0?"$ "+Number(rowData.outTotAmt).toLocaleString("en-US"):"-$ "+Number(rowData.outTotAmt*-1).toLocaleString("en-US"),
            net: isNaN(rowData.net)?"-":rowData.net>=0?"$ "+Number(rowData.net).toLocaleString("en-US"):"-$ "+Number(rowData.net*-1).toLocaleString("en-US"),
          }));
          setList(_inputData);
        } else {
          // setErrorMsg(res.data.message || "Processing failed.");
          // setErrorMsg(fni18n("처리가 실패하였습니다"));
          setErrorMsg(t("처리가 실패하였습니다"));
          handleErrorOpen();
        }
      });
      await getAPI(API.CASH.CLOSE_USER_DETAIL_TOTAL + userId, search).then(
        (res) => {
          const _inputData = res.data.result.map((rowData) => ({
            billDepAmt: isNaN(rowData.billDepAmt)?"-":rowData.billDepAmt>=0?"$ "+Number(rowData.billDepAmt).toLocaleString("en-US"):"-$ "+Number(rowData.billDepAmt*-1).toLocaleString("en-US"),
            coinDepAmt: isNaN(rowData.coinDepAmt)?"-":rowData.coinDepAmt>=0?"$ "+Number(rowData.coinDepAmt).toLocaleString("en-US"):"-$ "+Number(rowData.coinDepAmt*-1).toLocaleString("en-US"),
            checkDepAmt: isNaN(rowData.checkDepAmt)?"-":rowData.checkDepAmt>=0?"$ "+Number(rowData.checkDepAmt).toLocaleString("en-US"):"-$ "+Number(rowData.checkDepAmt*-1).toLocaleString("en-US"),
            inTotalAmt: isNaN(rowData.inTotAmt)?"-":rowData.inTotAmt>=0?"$ "+Number(rowData.inTotAmt).toLocaleString("en-US"):"-$ "+Number(rowData.inTotAmt*-1).toLocaleString("en-US"),
            billDisAmt: isNaN(rowData.billDisAmt)?"-":rowData.billDisAmt>=0?"$ "+Number(rowData.billDisAmt).toLocaleString("en-US"):"-$ "+Number(rowData.billDisAmt*-1).toLocaleString("en-US"),
            coinDisAmt: isNaN(rowData.coinDisAmt)?"-":rowData.coinDisAmt>=0?"$ "+Number(rowData.coinDisAmt).toLocaleString("en-US"):"-$ "+Number(rowData.coinDisAmt*-1).toLocaleString("en-US"),
            outTotalAmt: isNaN(rowData.outTotAmt)?"-":rowData.outTotAmt>=0?"$ "+Number(rowData.outTotAmt).toLocaleString("en-US"):"-$ "+Number(rowData.outTotAmt*-1).toLocaleString("en-US"),
            net: isNaN(rowData.net)?"-":rowData.net>=0?"$ "+Number(rowData.net).toLocaleString("en-US"):"-$ "+Number(rowData.net*-1).toLocaleString("en-US"),
          }));
          setTotal(_inputData);
        }
      );
    } else {
      // setErrorMsg("unknwon error");
      // setErrorMsg(fni18n("알 수 없는 오류가 발생하였습니다"));
      setErrorMsg(t("알 수 없는 오류가 발생하였습니다"));
      handleErrorOpen();
    }
  }

  return (
    <div className="main-container" style={{ width: "99%" }}>
      <div className="contents">
        <Box>
          <TableContainer className="table-container">
            <Table size="small" className="table">
              <TableBody>
                <TableCell className="table-cell-title">{fni18n("지점")}</TableCell>
                <TableCell className="table-cell">
                  <UTextField defaultValue={storeCd} disabled={true} />
                </TableCell>
                <TableCell className="table-cell-title">{fni18n("사원번호")}</TableCell>
                <TableCell className="table-cell">
                  <UTextField defaultValue={userId} disabled={true} />
                </TableCell>
                <TableCell className="table-cell-title">{fni18n("일자")}</TableCell>
                <TableCell className="table-cell" colSpan={3}>
                  {/* 날짜선택 */}
                  <UDatePickers
                    onChange={onSearchChange}
                    startDate={date}
                    endDate={date}
                  />
                </TableCell>
              </TableBody>
            </Table>
          </TableContainer>
          <div className="search">
            <UButton icon="Search" onButtonClick={onButtonClick}>
              조회
            </UButton>
          </div>
        </Box>
        <UTableTotal
          columns={columns}
          rows={list}
          total={total}
          onSelectedRowChange={onSelectedRows}
        />
        {/* 오류 확인 팝업  */}
        <UAlertDialog
          message={errorMsg}
          open={errorPopupOpen}
          onClose={handleErrorClose}
        />
      </div>
    </div>
  );
}
